import { __assign, __awaiter, __generator } from "tslib";
import { isFocusableHtmlElement } from '@office-start/dom-utility';
import { getReferralFromFileLocation } from '@office-start/file-utility';
import { ShareControlMode, } from '@office-start/share-types';
import { getLocation } from '@office-start/url-parser-utility';
var iframeHtmlTemplate = '<!DOCTYPE html><html><head></head><body><form id="shareform" action="SHAREAPIENDPOINT" method="post"><input type="text" name="context" value="POSTJSON" style="display: none"/><input type="text" name="access_token" value="TOKENVALUE" style="display: none"/></form></body></html>';
var getShareTokenInfo = function (item) {
    if (item.type === 'Consumer') {
        return {
            accessTokenConsumer: 'Graph',
            resourceUrl: '',
            webAbsoluteUrl: item.url,
        };
    }
    var parsedItemUrlUrl = getLocation(item.url);
    return {
        accessTokenConsumer: getReferralFromFileLocation(item.url) ===
            "Documents" /* KnownWorkloadReferralNames.OneDrive */
            ? 'OneDrive'
            : 'SharePoint',
        resourceUrl: parsedItemUrlUrl
            ? "".concat(parsedItemUrlUrl.protocol, "//").concat(parsedItemUrlUrl.hostname)
            : '',
        webAbsoluteUrl: item.siteUrl,
    };
};
export function getShareControlIdentifier(item) {
    if (item.type === 'Consumer') {
        return {
            listItemId: item.listItemId,
        };
    }
    // $TODO: evlave - Re-enable once confirmed with Lists/ODSP team
    // In order to share a list, 'item' must meet the following criteria:
    // - listId must be present and populated
    // - listItemId should be falsy
    // - listItemUniqueId should falsy or the empty guid
    // if (
    //     !!item.listId &&
    //     !item.listItemId &&
    //     (!item.listItemUniqueId ||
    //         item.listItemUniqueId === '00000000-0000-0000-0000-000000000000')
    // ) {
    //     return {
    //         listId: item.listId,
    //         isListSharing: true,
    //     };
    // }
    if ((item === null || item === void 0 ? void 0 : item.listId) && (item === null || item === void 0 ? void 0 : item.listItemId)) {
        return {
            listId: item.listId,
            listItemId: item.listItemId,
        };
    }
    if (item === null || item === void 0 ? void 0 : item.listItemUniqueId) {
        return {
            uniqueId: item.listItemUniqueId,
            isFolder: false,
        };
    }
    // Share control handles encoding, so just pass in decoded url. There are certain filenames (like "@#$&.pptx") that are not handled correctly by the control if encoded.
    // Note: sending a decoded URL doesn't work for filenames that include strings that correspond to encoded ASCII control characters (%00-%1F and %7F). So for example a filename
    // "Document %00.docx" will not work correctly with the share control right now, but "Document %20.docx" will. Rather than trying to detect these special sequences here,
    // we will simply pass the decoded URL and ask the Share control team to fix their handling of these special sequences. Also, the share control team's official recommendation is
    // to pass in decoded URLs.
    return {
        itemUrl: decodeURIComponent(item.url),
    };
}
function getDarkModeTheme() {
    return {
        palette: {
            themePrimary: '#3A96DD',
            themeLighterAlt: '#eff6fc',
            themeLighter: '#deecf9',
            themeLight: '#c7e0f4',
            themeTertiary: '#71afe5',
            themeSecondary: '#2b88d8',
            themeDarkAlt: '#106ebe',
            themeDark: '#004578',
            themeDarker: '#34365c',
            neutralLighterAlt: '#292827',
            neutralLighter: '#323130',
            neutralLight: '#3B3A39',
            neutralQuaternaryAlt: '#484644',
            neutralQuaternary: '#605E5C',
            neutralTertiaryAlt: '#484644',
            neutralTertiary: '#A19F9D',
            neutralSecondary: '#BEBBB8',
            neutralPrimaryAlt: '#E1DFDD',
            neutralPrimary: '#F3F2F1',
            neutralDark: '#FAF9F8',
            redDark: '#FF4343',
            black: '#FFFFFF',
            white: '#252423',
            primaryBackground: '#f9f8f7',
            primaryText: '#252423',
            bodyBackground: '#252423',
            bodyText: '#252423',
            disabledBackground: '#3B3A39',
            disabledText: '#c8c8c8',
        }, // palette colors given by Edgar Banguero
    };
}
function getStyleForMode(mode, mobile) {
    var width = mobile ? '100%' : '320px';
    switch (mode) {
        case ShareControlMode.Share:
            return { width: width, height: '400px' };
        case ShareControlMode.CopyLink:
            return { width: width, height: '238px' };
        case ShareControlMode.AtMention:
            return { width: width, height: '238px' };
        default:
            return { width: width, height: '150px' };
    }
}
export function createShareControl(_a, _b) {
    var item = _a.item, fetchAccessToken = _a.fetchAccessToken, shareApiUrl = _a.shareApiUrl, iframeElement = _a.iframeElement, isMsa = _a.isMsa, tenantId = _a.tenantId, mode = _a.mode, organizationName = _a.organizationName, correlationId = _a.correlationId, onError = _a.onError, onLogTokenClaims = _a.onLogTokenClaims, setStyle = _a.setStyle, onGrantAccessComplete = _a.onGrantAccessComplete, navId = _a.navId, scenarioId = _a.scenarioId, defaultRecipients = _a.defaultRecipients, darkMode = _a.darkMode, onOpen = _a.onOpen, onClose = _a.onClose, onShareCompleted = _a.onShareCompleted, onShareReady = _a.onShareReady, tokenProviderEnabled = _a.tokenProviderEnabled;
    var listenForClose = _b.listenForClose, closeControl = _b.closeControl;
    return __awaiter(this, void 0, void 0, function () {
        var _c, accessTokenConsumer, resourceUrl, webAbsoluteUrl, tokenResponse, error_1, authToken, shareInfo, json, iframeHtml, iframeDocument, errorTimeout, grantAccessCompleteCalled, previousActiveElement, handleShareMessage;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _c = getShareTokenInfo(item), accessTokenConsumer = _c.accessTokenConsumer, resourceUrl = _c.resourceUrl, webAbsoluteUrl = _c.webAbsoluteUrl;
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchAccessToken(accessTokenConsumer, false, resourceUrl)];
                case 2:
                    tokenResponse = _d.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _d.sent();
                    onError(error_1);
                    return [2 /*return*/];
                case 4:
                    if (!tokenResponse || !tokenResponse.token) {
                        onError('Unable to get token for share control');
                        return [2 /*return*/];
                    }
                    setStyle(getStyleForMode(mode));
                    authToken = isMsa
                        ? tokenResponse.token.trim()
                        : "Bearer ".concat(tokenResponse.token.trim());
                    shareInfo = __assign(__assign({}, getShareControlIdentifier(item)), { authToken: authToken, clientId: 'officecom', correlationId: correlationId, defaultRecipients: defaultRecipients, isODB: isMsa ? false : accessTokenConsumer === 'OneDrive', itemName: item.name, mode: mode, navId: navId, scenarioId: scenarioId, organizationName: organizationName, siteSubscriptionId: tenantId, theme: darkMode ? getDarkModeTheme() : undefined, // TODO: Should probably pass theme from react context
                        webAbsoluteUrl: webAbsoluteUrl, hasTokenProvider: tokenProviderEnabled });
                    json = JSON.stringify(shareInfo).replace(/"/g, '&quot;');
                    iframeHtml = iframeHtmlTemplate
                        .replace('SHAREAPIENDPOINT', shareApiUrl)
                        .replace('POSTJSON', function () { return json; })
                        .replace('TOKENVALUE', function () { return authToken; });
                    iframeDocument = iframeElement.contentDocument;
                    if (iframeDocument) {
                        // eslint-disable-next-line @microsoft/sdl/no-inner-html
                        iframeDocument.body.innerHTML = iframeHtml;
                        iframeDocument.getElementById('shareform').submit();
                    }
                    errorTimeout = setTimeout(function () {
                        onError('Timed out on load');
                    }, 15000);
                    grantAccessCompleteCalled = false;
                    previousActiveElement = document.activeElement;
                    onOpen && onOpen();
                    handleShareMessage = function (event) {
                        var _a, _b, _c, _d, _e, _f;
                        var origin = event.origin;
                        if (!shareApiUrl.startsWith(origin)) {
                            return;
                        }
                        var data = JSON.parse(event.data);
                        switch (data.name) {
                            case 'share_completed':
                                // ** Add this back during cleanup ** //
                                /*if (onShareCompleted && data.shareType) {
                                    onShareCompleted(data.shareType);
                                }*/
                                // ** Temporary for logging, get rid of this later ** //
                                if (onShareCompleted && data.shareType) {
                                    if (!tokenProviderEnabled) {
                                        onShareCompleted(data.shareType);
                                        break;
                                    }
                                    onShareCompleted(data.shareType, ((_a = data.claimsChallenge) === null || _a === void 0 ? void 0 : _a.claims)
                                        ? 'Share_Complete is called, and claims are present'
                                        : 'Share_Complete is called, but claims are not present');
                                }
                                break;
                            // case 'share_started':
                            //     // Dispatched when the sharing UI page begins to execute before scripts are loaded.
                            //     break;
                            case 'share_ready':
                                // Dispatched when sharing UI has fully rendered. When received, hosts should hide their loading UI and make the sharing UI visible.
                                setTimeout(function () { return iframeElement.focus(); }, 0);
                                clearTimeout(errorTimeout);
                                if (onShareReady) {
                                    onShareReady(Date.now());
                                }
                                break;
                            // case 'share_uiReady':
                            //     // Dispatched when the sharing dialog state changes from loading to completed (either error or success).
                            //     break;
                            case 'share_error':
                                clearTimeout(errorTimeout);
                                onError(data.errorMessage || 'error not provided', data);
                                onGrantAccessComplete === null || onGrantAccessComplete === void 0 ? void 0 : onGrantAccessComplete.call(false, false, true);
                                break;
                            case 'share_resize':
                                // Width and Height are just minimum values
                                var width = data.width, height = data.height;
                                if (width !== 0 && height !== 0) {
                                    setStyle({
                                        width: "".concat(width, "px"),
                                        height: "".concat(height, "px"),
                                    });
                                }
                                break;
                            case 'share_dismiss':
                                // Dispatched when user clicks the "X" button.
                                closeControl();
                                if (isFocusableHtmlElement(previousActiveElement)) {
                                    previousActiveElement.focus();
                                }
                                break;
                            case 'share_grantAccessCompleted':
                                var completed = data.successful;
                                if (completed && onGrantAccessComplete) {
                                    onGrantAccessComplete(completed);
                                    grantAccessCompleteCalled = true;
                                }
                                break;
                            // case 'share_copyLinkClicked':
                            case 'share_getToken':
                                // Dispatched when the share dialog is requesting an auth token, with optional claims challenge (as in LLT/SSM). This event is only fired when the SharingContext has hasTokenProvider set to true.
                                /*** --- Once we have the token we send it to ODSP sharing UI then get back some information and pass it back to the iFrame in a postMessage() --- ***/
                                if (!tokenProviderEnabled) {
                                    break;
                                }
                                try {
                                    tokenResponse = fetchAccessToken(accessTokenConsumer, false, resourceUrl, undefined, undefined, (_b = data.claimsChallenge) === null || _b === void 0 ? void 0 : _b.claims).then(function (response) {
                                        var _a, _b, _c, _d, _e, _f, _g;
                                        if (!response) {
                                            // Clean this up and add back once we check logging for claims in ShareTokenClaims flight
                                            /*onError(
                                                'Unable to get token for share control',
                                            );*/
                                            // Get rid of this if adding up above ^^
                                            onError(((_a = data.claimsChallenge) === null || _a === void 0 ? void 0 : _a.claims)
                                                ? 'Unable to get token for share control, but claims are present'
                                                : 'Unable to get token for share control, and claims are not present');
                                            if (onLogTokenClaims) {
                                                onLogTokenClaims(((_b = data.claimsChallenge) === null || _b === void 0 ? void 0 : _b.claims)
                                                    ? 'Unable to get token for share control, but claims are present'
                                                    : 'Unable to get token for share control, and claims are not present', (_c = data.claimsChallenge) === null || _c === void 0 ? void 0 : _c.claims);
                                            }
                                            (_d = iframeElement === null || iframeElement === void 0 ? void 0 : iframeElement.contentWindow) === null || _d === void 0 ? void 0 : _d.postMessage(JSON.stringify({
                                                name: 'share_newToken',
                                                error: 'Unable to get token for share control',
                                            }), origin);
                                            return;
                                        }
                                        (_e = iframeElement === null || iframeElement === void 0 ? void 0 : iframeElement.contentWindow) === null || _e === void 0 ? void 0 : _e.postMessage(JSON.stringify({
                                            name: 'share_newToken',
                                            token: response.token.trim(),
                                        }), origin);
                                        // Clean this up and don't log once we verify that claims is getting properly populated
                                        if (onLogTokenClaims) {
                                            onLogTokenClaims(((_f = data.claimsChallenge) === null || _f === void 0 ? void 0 : _f.claims)
                                                ? 'Share get token is called and claims are present'
                                                : 'Share get token is called and claims are not present', (_g = data.claimsChallenge) === null || _g === void 0 ? void 0 : _g.claims);
                                        }
                                    });
                                }
                                catch (error) {
                                    // Clean this up and once we verify that claims is getting properly populated
                                    onError(((_c = data.claimsChallenge) === null || _c === void 0 ? void 0 : _c.claims)
                                        ? 'Unable to fetch token for share control, but claims is present and passed in'
                                        : 'Unable to fetch token for share control, and claims is not present');
                                    if (onLogTokenClaims) {
                                        onLogTokenClaims(((_d = data.claimsChallenge) === null || _d === void 0 ? void 0 : _d.claims)
                                            ? 'Unable to fetch token for share control, but claims is present and passed in'
                                            : 'Unable to fetch token for share control, and claims is not present', (_e = data.claimsChallenge) === null || _e === void 0 ? void 0 : _e.claims);
                                    }
                                    (_f = iframeElement === null || iframeElement === void 0 ? void 0 : iframeElement.contentWindow) === null || _f === void 0 ? void 0 : _f.postMessage(JSON.stringify({
                                        name: 'share_newToken',
                                        error: 'Error while fetching token for share control',
                                    }), origin);
                                    return;
                                }
                                break;
                            // case 'share_linkSettingsCompletedV2':
                            // case 'share_outlookClicked':
                            // case 'share_peoplePickedFocused':
                            // case 'share_sendClicked':
                            default:
                                break;
                        }
                    };
                    window.addEventListener('message', handleShareMessage);
                    listenForClose().subscribe(function () {
                        onClose && onClose();
                        if (handleShareMessage) {
                            window.removeEventListener('message', handleShareMessage);
                        }
                        if (onGrantAccessComplete && !grantAccessCompleteCalled) {
                            onGrantAccessComplete(false, true);
                        }
                    });
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=createShareControl.js.map